export default __webpack_public_path__ + "svTransBannerEn.9734ec12f0816601b9216fc6681b47c9.png";